import { globalAxios } from "../index";
export default {
  namespaced: true,
  state: {
    productList: [],
    productType: [],
    productDetail: {},
    productEditDetail: {},
    lazyProduct: [],
    lazyPage: 1,
    choice_list: [],
  },
  mutations: {
    incLazyPage(state) {
      state.lazyPage++;
    },
    setLazyPage(state, count) {
      state.lazyPage = count;
    },
    setLazyProduct(state, data) {
      state.lazyProduct = data;
    },
    setDataProductDetail(state, data) {
      state.productDetail = data;
    },
    continueProductEdit(state) {
      state.productDetail = JSON.parse(
        JSON.stringify(state.productEditDetail.product_edit_dumps)
      );
    },
    setDataProductEditDetail(state, data) {
      state.productEditDetail = data;
    },
    setDataProductList(state, data) {
      state.productList = data;
    },
    setDataProductType(state, data) {
      state.productType = data;
    },
    addProduct(state, data) {
      state.productList.push(data);
      if (state.lazyProduct.length / 10 < state.lazyPage - 1) {
        state.lazyProduct.push(data);
      }
    },
    duppliecatedProduct(state, payload) {
      let index = state.productList.findIndex(
        (val) => val.product_id == payload.form.product_id
      );
      state.productList.splice(index + 1, 0, payload.data);
      state.lazyProduct.splice(index + 1, 0, payload.data);
    },
    editProduct(state, data) {
      let index = state.productList.findIndex(
        (val) => val.product_id == data.product_id
      );
      state.productList.splice(index, 1, {
        product_id: data.product_id,
        product_code: data.product_code,
        product_key: data.product_key,
        product_name_th: data.product_name_th,
        product_description_th: data.product_description_th,
        product_name_en: data.product_name_en,
        product_description_en: data.product_description_en,
        product_name_cn: data.product_name_cn,
        product_description_cn: data.product_description_cn,
        product_approve: data.product_approve,
        product_status: data.product_status,
        product_sale_price: data.product_sale_price,
        product_base_price: data.product_base_price,
        product_pos_sale_price: data.product_pos_sale_price,
        product_pos_base_price: data.product_pos_base_price,
        product_best_seller: data.product_best_seller,
        product_note: data.product_note,
        product_type_id: data.product_type_id,
        product_recommend: data.product_recommend,
        product_on_hold_msg: data.product_on_hold_msg,
        product_reject_msg: data.product_reject_msg,
        product_store_id: data.product_store_id,
        product_series: data.product_series,
        product_image: data.product_image,
      });

      let indexLazy = state.lazyProduct.findIndex(
        (val) => val.product_id == data.product_id
      );

      state.lazyProduct.splice(indexLazy, 1, {
        product_id: data.product_id,
        product_code: data.product_code,
        product_key: data.product_key,
        product_name_th: data.product_name_th,
        product_description_th: data.product_description_th,
        product_name_en: data.product_name_en,
        product_description_en: data.product_description_en,
        product_name_cn: data.product_name_cn,
        product_description_cn: data.product_description_cn,
        product_approve: data.product_approve,
        product_status: data.product_status,
        product_sale_price: data.product_sale_price,
        product_base_price: data.product_base_price,
        product_pos_sale_price: data.product_pos_sale_price,
        product_pos_base_price: data.product_pos_base_price,
        product_best_seller: data.product_best_seller,
        product_note: data.product_note,
        product_type_id: data.product_type_id,
        product_recommend: data.product_recommend,
        product_on_hold_msg: data.product_on_hold_msg,
        product_reject_msg: data.product_reject_msg,
        product_store_id: data.product_store_id,
        product_series: data.product_series,
        product_image: data.product_image,
      });
    },
    deleteProduct(state, product_id) {
      let index = state.productList.findIndex(
        (val) => val.product_id == product_id
      );
      state.productList.splice(index, 1);

      let indexLazy = state.lazyProduct.findIndex(
        (val) => val.product_id == product_id
      );
      state.lazyProduct.splice(indexLazy, 1);
    },
    addProductType(state, data) {
      state.productType.push(data);
    },
    editProductType(state, data) {
      let index = state.productType.findIndex(
        (val) => val.product_type_id == data.product_type_id
      );
      state.productType.splice(index, 1, data);
    },
    deleteProductType(state, product_type_id) {
      let index = state.productType.findIndex(
        (val) => product_type_id == val.product_type_id
      );
      state.productType.splice(index, 1);
    },
    duplicateProduct(state, formCommit) {
      let index = state.productList.findIndex(
        (val) => val.product_id == formCommit.product_id
      );
      state.productList.splice(index + 1, 0, formCommit.res_data);

      let indexLazy = state.lazyProduct.findIndex(
        (val) => val.product_id == formCommit.product_id
      );
      state.lazyProduct.splice(indexLazy + 1, 0, formCommit.res_data);
    },
    setListChoiceByStore(state, data) {
      state.choice_list = data;
    },
  },
  actions: {
    duplicateProduct({ commit, rootState }, product_id) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .post(
          rootState.baseAPIURL + "restaurant/duplicateProduct/" + product_id,
          {},
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            let formCommit = {
              product_id,
              res_data: res.data.data,
            };
            commit("duplicateProduct", formCommit);
            return res.data.data;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    deleteProductType({ commit, rootState }, product_type_id) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .delete(
          rootState.baseAPIURL +
            "restaurant/delete/productType/" +
            product_type_id,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("deleteProductType", product_type_id);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    editProductType({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .put(
          rootState.baseAPIURL +
            "restaurant/edit/productType/" +
            form.product_type_id,
          form,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("editProductType", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    addProductType({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      form.product_type_store_id = rootState.Auth.refeshStoreID;
      return globalAxios
        .post(
          rootState.baseAPIURL + "restaurant/create/productType",
          form,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("addProductType", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    changeStatusProduct({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      form.product_store_id = rootState.Auth.refeshStoreID;
      return globalAxios
        .patch(
          rootState.baseAPIURL +
            "restaurant/edit/toggleStatusProduct/" +
            form.product_id,
          { product_status: form.product_status },
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    deleteProduct({ commit, rootState }, product_id) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .delete(
          rootState.baseAPIURL +
            "restaurant/delete/product/" +
            product_id +
            "/store/" +
            rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("deleteProduct", product_id);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    sortProduct({ rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .put(rootState.baseAPIURL + "edit_product_series", form, axiosConfig)
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    editProduct({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      form.product_store_id = rootState.Auth.refeshStoreID;
      return globalAxios
        .put(
          rootState.baseAPIURL2 + "restaurant/edit/product/" + form.product_id,
          form,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("editProduct", res.data.data);
            return res.data.data;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },

    addProduct({ commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      let clone = JSON.parse(JSON.stringify(form));
      clone.product_store_id = rootState.Auth.refeshStoreID;
      delete clone.product_id;
      return globalAxios
        .post(
          rootState.baseAPIURL2 + "restaurant/create/product",
          clone,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            if ("product_id" in form) {
              commit("duppliecatedProduct", { form, data: res.data.data });
            } else {
              commit("addProduct", res.data.data);
            }
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    fetchDataProductDetail({ commit, rootState }, product_id) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };

      return globalAxios
        .get(
          rootState.baseAPIURL + "restaurant/detailProduct/" + product_id,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return res.data.data;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    fetchDataProductType({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .get(
          rootState.baseAPIURL2 +
            "restaurant/allProductTypeByStore/" +
            rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("setDataProductType", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    fetchDataProductList({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .get(
          rootState.baseAPIURL2 +
            "restaurant/allProductByStore/" +
            rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("setDataProductList", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    getListChoiceByStore({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .get(
          rootState.baseAPIURL2 +
            "get/list_choice/by_store?store_id=" +
            rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then((res) => {
          commit("setListChoiceByStore", res.data.data);
          return true;
        })
        .catch((err) => false);
    },
    changeStatusChoice({ rootState }, form) {
      let payload = {
        store_id: rootState.Auth.refeshStoreID,
        choice_id: form.choice_id,
        choice_status: form.choice_status,
      };
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .put(
          rootState.baseAPIURL2 + "change_status/choice",
          payload,
          axiosConfig
        )
        .then((res) => {
          return true;
        })
        .catch((err) => false);
    },
  },
  getters: {},
};
